export default "__VITE_ASSET__B2$gi7aG__"